import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import {
  apiSendOtp,
  apiSignIn,
  apiSignOut,
  apiVarifyOtp,
  setSignOut,
} from "services/AuthService";
import {
  onSignInSuccess,
  onSignOutSuccess,
  setReq_id,
  setToggleDevicePopUp,
  setUserId,
  setUserTemp,
} from "store/auth/sessionSlice";
import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";
import { Notification, toast } from "../../components/ui";
import React from "react";
function useAuth() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();

  const query = useQuery();

  const { token, signedIn, cta } = useSelector((state) => state.auth.session);
  const { pages } = useSelector((state) => state.auth.user);

  const signIn = async ({ email, password }) => {
    try {
      const resp = await apiSignIn({ email, password });
      if (resp.data.result) {
        dispatch(
          onSignInSuccess({
            token: resp.data.result.token,
            cta: resp.data.result.user[0].cta,
          })
        );
        if (resp.data.result.user) {
          dispatch(setUser(resp.data.result.user[0]));
          // dispatch( setNav(resp.data.result.user[0].nav ))
        }
        const redirectUrl = query.get(REDIRECT_URL_KEY);
        navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath);
        return {
          status: "success",
          message: "",
        };
      }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message || errors.toString(),
      };
    }
  };

  const sendOtp = async ({ mobile }) => {
    try {
      const resp = await apiSendOtp({ mobile });
      if (resp.data.result) {
        dispatch(setReq_id(resp.data.result.request_id));

        return {
          status: "success",
          message: "",
        };
      }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message || errors.toString(),
      };
    }
  };
  const varifyOtp = async (data) => {
    try {
      const resp = await apiVarifyOtp(data);
      if (
        resp.data.result &&
        resp.data.result.token &&
        resp.data.result.user.length
      ) {
        if (resp.data.result.user) {
          dispatch(setUserId(resp.data.result.user[0].id));
        }
        if (
          (resp.data.result.user[0].devicefingerprint === null ||
            resp.data.result.user[0].devicefingerprint === "" ||
            resp.data.result.user[0].devicefingerprint === undefined) &&
          resp.data.result.user[0].checkdevice != 1
        ) {
          dispatch(setUserTemp(resp.data.result));
          dispatch(setToggleDevicePopUp(true));
        } else {
          dispatch(
            onSignInSuccess({
              token: resp.data.result.token,
              cta: resp.data.result.user[0].cta,
            })
          );
          if (resp.data.result.user) {
            dispatch(setUser(resp.data.result.user[0]));
          }
          const redirectUrl = query.get(REDIRECT_URL_KEY);
          navigate(
            redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
          );
        }
        return {
          status: "success",
          message: "",
        };
      } else {
        if (resp.data.result === null) {
          toast.push(
            <Notification title={"Failure"} type="danger" duration={2500}>
              {resp.data.result.message}
            </Notification>,
            {
              placement: "top-center",
            }
          );
        } else {
          toast.push(
            <Notification title={"Login Failed"} type="danger" duration={2500}>
              Please login with registered browser
            </Notification>,
            {
              placement: "top-center",
            }
          );
        }
        return {
          status: "failure",
          message: "",
        };
      }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message || errors.toString(),
      };
    }
  };

  const handleSignOut = () => {
    dispatch(setToggleDevicePopUp(false));
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    navigate(appConfig.unAuthenticatedEntryPath);
  };

  const signOut = async () => {
    try {
      let param = { id: user.id };
      let res = await setSignOut(param);
      await apiSignOut();
      handleSignOut();
    } catch (errors) {
      handleSignOut();
    }
  };

  return {
    authenticated: token && signedIn && cta && pages,
    signIn,
    signOut,
    sendOtp,
    varifyOtp,
  };
}

export default useAuth;
